import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DeviceSizes } from '../enum/device-size';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DeviceSizeService {
  deviceSize$ = new BehaviorSubject<any>(null);

  constructor(
    private breakpointObserver: BreakpointObserver
  ) {
    this._observeBreakpoints();
  }

  isLargerThan(breakpointDeviceSize: DeviceSizes, deviceToCompare: DeviceSizes) {
    return breakpointDeviceSize < deviceToCompare;
  }

  private _observeBreakpoints(): void {
    this.breakpointObserver.observe([
      '(min-width: 400px) and (max-width: 575px)',
      '(min-width: 576px) and (max-width: 767px)',
      '(min-width: 768px) and (max-width: 991px)',
      '(min-width: 992px) and (max-width: 1199px)',
      '(min-width: 1200px) and (max-width: 1365px)',
      '(min-width: 1366px) and (max-width: 1439px)',
      '(min-width: 1440px)'
    ]).pipe(
      distinctUntilChanged()
    ).subscribe((size) => {
      if (!size.matches) {
        this.deviceSize$.next(DeviceSizes.mobile);
      } else if (this.breakpointObserver.isMatched('(min-width: 400px) and (max-width: 575px)')) {
        this.deviceSize$.next(DeviceSizes.largeMobile);
      } else if (this.breakpointObserver.isMatched('(min-width: 576px) and (max-width: 767px)')) {
        this.deviceSize$.next(DeviceSizes.tablet);
      } else if (this.breakpointObserver.isMatched('(min-width: 768px) and (max-width: 991px)')) {
        this.deviceSize$.next(DeviceSizes.smallLaptop);
      } else if (this.breakpointObserver.isMatched('(min-width: 992px) and (max-width: 1199px)')) {
        this.deviceSize$.next(DeviceSizes.laptop);
      } else if (this.breakpointObserver.isMatched('(min-width: 1200px) and (max-width: 1365px)')) {
        this.deviceSize$.next(DeviceSizes.largeLaptop);
      } else if (this.breakpointObserver.isMatched('(min-width: 1366px) and (max-width: 1439px)')) {
        this.deviceSize$.next(DeviceSizes.large);
      } else if (this.breakpointObserver.isMatched('(min-width: 1440px)')) {
        this.deviceSize$.next(DeviceSizes.huge);
      } else {
        this.deviceSize$.next(DeviceSizes.unknown);
      }
    });
  }
}
